/**
 * Refresco periódico de tasa de cambio USD/Bs en el facturador.
 */

const REFRESH_INTERVAL_MS = 2 * 60 * 1000;

function applyExchangeRate(win, nuevaTasa, $) {
	const prev = parseFloat(win.TASA_DOLAR) || 0;
	const next = parseFloat(nuevaTasa) || 0;
	if (next <= 0) return false;
	if (Math.abs(next - prev) <= 0.0001) return false;

	win.TASA_DOLAR = next;
	window.TASA_DOLAR = next;

	if (typeof win.posknActualizarPreciosEnPantalla === 'function') {
		win.posknActualizarPreciosEnPantalla();
	}

	const $val = $('#poskn-tasa-value');
	if ($val.length) {
		$val.text(next.toFixed(2));
	} else {
		const $tasaEl = $('#poskn-tasa-display, #tasa-display');
		if ($tasaEl.length) {
			$tasaEl.text(`Tasa: $1 = Bs. ${next.toFixed(2)}`);
		}
	}

	return true;
}

export function initExchangeRateRefresh(win, $) {
	if (win._posknExchangeRateBound) return;
	win._posknExchangeRateBound = true;

	function refrescarTasaFacturador() {
		const cfg = win.POSKN_API_CONFIG || {};
		const url = cfg.ajaxUrl || win.ajaxurl || 'pos-ajax.php';
		const nonce = win.posNonce || cfg.posNonce || '';
		$.ajax({
			url,
			type: 'POST',
			data: { action: 'poskn_get_exchange_rate', nonce, _t: Date.now() },
			dataType: 'json',
			cache: false,
			timeout: 10000,
		})
			.done((res) => {
				if (res && res.success && res.data && res.data.tasa_dolar > 0) {
					applyExchangeRate(win, res.data.tasa_dolar, $);
				}
			})
			.fail(() => {});
	}

	win.refrescarTasaFacturador = refrescarTasaFacturador;
	win.posknApplyExchangeRate = (tasa) => applyExchangeRate(win, tasa, $);

	function scheduleRefresh() {
		refrescarTasaFacturador();
	}

	$(() => {
		// Tras el inline script del facturador (TASA_DOLAR, POSKN_MULTIMONEDA).
		win.setTimeout(scheduleRefresh, 0);
		win.setInterval(refrescarTasaFacturador, REFRESH_INTERVAL_MS);
		$(win).on('focus', refrescarTasaFacturador);
		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'visible') refrescarTasaFacturador();
		});
	});
}
